import { configureStore } from '@reduxjs/toolkit';
import { appSlice } from './app.slice';

export const store = configureStore({
  reducer: {
    app: appSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['product-analysis/changeCurrentDate', 'app/fetchUser/pending', 'app/fetchUser/rejected'],
        ignoredPaths: ['product.datePreset', 'mediaConversionReport.options.dateTime', 'adsReport.options.dateTime'],
      },
    }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
